import { clsx } from 'clsx'

interface Props {
  className?: string
}

export const LivePulse = ({ className }: Props) => {
  return (
    <span className={clsx('relative flex size-3', className)}>
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-action-destructive opacity-75"></span>
      <span className="relative inline-flex size-3 rounded-full bg-action-destructive"></span>
    </span>
  )
}
